import React, { useEffect, useMemo } from 'react';
import { getWebAbsPath } from '../../../../util/path';
import { useDispatch } from 'react-redux';
import { IMPRESSION_TYPE } from '../../../../pages/hooks/DiffRetainerHooks/useRetainerRequestForm';
import {
    SET_BOTH_LOWER_TYPE_BITE_RAMP_TEETH_SELECTIONS,
    SET_BOTH_UPPER_TYPE_BITE_RAMP_TEETH_SELECTIONS,
    SET_SINGLE_TYPE_BITE_RAMP_TEETH_SELECTIONS,
} from '../../../../store/DiffRetainers/actionType';

function TeethPosition({
    teeth,
    side,
    disabled = false,
    selectedTooth,
    setSelectedTooth,
    isTab,
    impressionType,
    subType,
    currentEditingType,
}) {
    const dispatch = useDispatch();
    // reset selected tooth when component is disabled
    useEffect(() => {
        if (disabled) {
            setSelectedTooth([]);
        }
    }, [disabled]);

    const isValidForSaveBothType = useMemo(() => {
        if (!subType || !currentEditingType) return false;
        return subType === currentEditingType;
    }, [subType, currentEditingType]);

    const handleSelectTeeth = (value) => {
        const dispatchTeeth = (payload) => {
            if (impressionType === IMPRESSION_TYPE.UPPER || impressionType === IMPRESSION_TYPE.LOWER) {
                dispatch({ type: SET_SINGLE_TYPE_BITE_RAMP_TEETH_SELECTIONS, payload: payload });
            }
            if (impressionType === IMPRESSION_TYPE.UPPER_AND_LOWER && isValidForSaveBothType) {
                const actionType =
                    subType === 'Upper'
                        ? SET_BOTH_UPPER_TYPE_BITE_RAMP_TEETH_SELECTIONS
                        : SET_BOTH_LOWER_TYPE_BITE_RAMP_TEETH_SELECTIONS;
                dispatch({ type: actionType, payload: payload });
            }
        };

        const validToSaveInStore =
            isTab &&
            [IMPRESSION_TYPE.UPPER, IMPRESSION_TYPE.LOWER, IMPRESSION_TYPE.UPPER_AND_LOWER].includes(impressionType);
        if (selectedTooth.length === 0) {
            setSelectedTooth([value]);
            if (validToSaveInStore) {
                dispatchTeeth([value]);
            }
            return;
        }
        const found = selectedTooth.find((v) => v === value);
        if (found === undefined) {
            setSelectedTooth([...selectedTooth, value]);
            if (validToSaveInStore) {
                dispatchTeeth([...selectedTooth, value]);
            }
            return;
        }
        setSelectedTooth(selectedTooth.filter((v) => v !== value));
        if (validToSaveInStore) {
            dispatchTeeth(selectedTooth.filter((v) => v !== value));
        }
    };

    const handleClick = (e) => {
        const { left, top } = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - left;
        const y = e.clientY - top;

        for (let [_, objValue] of Object.entries(teeth)) {
            if (x > objValue.maxX || x < objValue.minX || y > objValue.maxY || y < objValue.minY) continue;
            for (let i = 0; i < objValue.values.length; i++) {
                const { value, boundX } = objValue.values[i];
                if (boundX < x) continue;
                console.log('value', value);
                handleSelectTeeth(value);
                break;
            }
            break;
        }
    };

    return (
        <div style={{ width: '1175px' }} tabIndex="0">
            <div
                style={{
                    width: 1175,
                    // height: 300,
                    height: 150,
                    'margin-top': '10px',
                    position: 'relative',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: `url("${getWebAbsPath(side == 'Top' ? '/img/prescriptionNotes/top_teeth_number_CS6.ai.png' : '/img/prescriptionNotes/bottom_teeth_number_CS6.ai.png')}")`,
                    cursor: disabled ? 'not-allowed' : 'default',
                }}
                onClick={(e) => {
                    // if (props.readOnly) return
                    // if (!this.validation("attachments")) return
                    if (disabled) return;
                    handleClick(e);
                }}
            >
                {selectedTooth.map((toothValue) => {
                    for (let [_, objValue] of Object.entries(teeth)) {
                        for (let { value, positionX, positionY } of objValue.values) {
                            if (value === toothValue) {
                                return (
                                    <img
                                        key={value}
                                        src={getWebAbsPath('/img/prescriptionNotes/checkSuccess.png')}
                                        alt="checked"
                                        style={{
                                            position: 'absolute',
                                            top: positionY - 10,
                                            left: positionX - 12,
                                            userSelect: 'none',
                                        }}
                                    />
                                );
                            }
                        }
                    }
                })}
            </div>
        </div>
    );
}

export default TeethPosition;
